import { StyleDeclaration, css } from 'aphrodite';
import { Avatar } from 'radix-ui';
import { AssigneeIcon } from '../svgs/icons/AssigneeIcon';
import { styleSheet } from './styles';

export function UserIconAvatar({ styleDeclaration }: { styleDeclaration?: StyleDeclaration }) {
	return (
		<Avatar.Root className={css(styleSheet.root, styleDeclaration)}>
			<Avatar.Fallback asChild>
				<AssigneeIcon style={{ color: 'white' }} />
			</Avatar.Fallback>
		</Avatar.Root>
	);
}
